import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import './App.css';
import SchedulePage from './BNP_core/pages/schedulePage';
import StatisticPage from './BNP_core/pages/statisticPage';
import InfoPage from './BNP_core/pages/infoPage';
import TestSend from './BNP_core/pages/testSendPage';
import PriorityPage from './BNP_core/pages/priorityPage';
import Navigation from './BNP_core/templates/navigation';
import Error from "./ui_core/message/errors";
import Сonfig from './config';

class App extends Component {
    constructor(props) {
        super();
        this.tools = {
            getParam: function(paramName) {
                const searchObj = {};
                const paramArr = window.location.search.slice(1).split('&');

                paramArr.forEach((item) => {
                    const keyVal = item.split('=');
                    searchObj[keyVal[0]] = keyVal[1];
                });

                return searchObj[paramName];
            },
            setData: function (dataArr) {
                const headers = new Headers({
                    'Content-Type': 'application/json',
                });
                const data = {
                    method:  'POST',
                    headers: headers,
                    body:    JSON.stringify(dataArr),
                };

                this.setState({
                    saveState: {
                        pending: true,
                        state: '',
                    }
                });

                return fetch(Сonfig.endpoint + '/schedule/update' + window.location.search, data)
                    .then(res => res.json());
            },
            getData: function (customPath, customSearch, method) {
                const config = {
                    method: method || 'GET',
                    credentials: 'include',
                };

                return fetch(Сonfig.endpoint + (customPath ? customPath : '/schedule/get') + (customSearch ? customSearch : ''), config)
                    .then(response => {
                        if (response.status >= 200 && response.status < 300) {
                            return Promise.resolve(response);
                        } else {
                            return Promise.reject(response);
                        }
                    })
                    .then(res => res.json())
                    .catch(async (response) => {
                        const getJSON = async (response) => {
                            return await response.json().then(jsonData => jsonData);
                        };
                        let res;
                        let message;

                        res = response;
                        if (response.body) {
                            res = await getJSON(response);
                        }

                        message = {
                            error: [
                                       'Status: ' + (response.status || response.name),
                                       res.error || '',
                                       response.statusText || '',
                                       res.message || '',
                                   ].join('<Br/>'),
                        };

                        this.setState({
                            message,
                        });

                        response.status === 403 && (window.location.href = Сonfig.endpoint + '/login?installation_id=' + window.sessionStorage.getItem('installationId'))

                        throw new Error(message);
                    });
            },
        };

    }

    render() {
        window.sessionStorage.setItem('installationId', this.tools.getParam('installationId'));
        window.sessionStorage.setItem('isEditor', this.tools.getParam('isEditor'));

        return (
            <div className="App">

                <Navigation/>
                <Switch>
                    <Route exact path="/" render={() => (<StatisticPage tools={this.tools}/>)}/>
                    {/*<Route exact path="/auth" render={() => (<AuthPage tools={this.tools}/>)}/>*/}
                    <Route exact path="/schedule" render={() => (<SchedulePage tools={this.tools} />)}/>
                    <Route exact path="/test_sends" render={() => (<TestSend tools={this.tools} />)}/>
                    <Route exact path="/priority" render={() => (<PriorityPage tools={this.tools} />)}/>
                    <Route exact path="/info" render={() => (<InfoPage tools={this.tools} />)}/>
                </Switch>
            </div>
        );
    }
}

export default App;
